
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Shield, Lock, Key } from "lucide-react";

export const SecuritySettings = () => {
  return (
    <div className="space-y-6">
      <Card className="backdrop-blur-sm bg-white/10 border border-gray-700/30">
        <CardHeader>
          <CardTitle className="flex items-center space-x-2 text-white">
            <Shield className="h-5 w-5 text-blue-400" />
            <span>Sicherheitseinstellungen</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-white">Zugriffskontrolle</h3>
            
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="2fa" className="text-gray-300">Zwei-Faktor-Authentifizierung</Label>
                <p className="text-sm text-gray-500">Zusätzliche Sicherheitsebene für Admin-Konten</p>
              </div>
              <Switch id="2fa" defaultChecked />
            </div>
            
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="ip-restriction" className="text-gray-300">IP-Beschränkung</Label>
                <p className="text-sm text-gray-500">Zugriff auf bestimmte IP-Adressen beschränken</p>
              </div>
              <Switch id="ip-restriction" />
            </div>
            
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="session-timeout" className="text-gray-300">Session-Timeout</Label>
                <p className="text-sm text-gray-500">Automatisches Abmelden nach Inaktivität</p>
              </div>
              <Switch id="session-timeout" defaultChecked />
            </div>
          </div>
          
          <div className="space-y-4 pt-4 border-t border-gray-700">
            <h3 className="text-lg font-medium text-white">Passwort-Richtlinien</h3>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label htmlFor="min-length" className="text-gray-300">Mindestlänge</Label>
                <Input id="min-length" type="number" defaultValue={12} min={8} max={32} className="bg-[#1A2433] border-gray-700 text-white" />
              </div>
              
              <div>
                <Label htmlFor="max-age" className="text-gray-300">Max. Alter (Tage)</Label>
                <Input id="max-age" type="number" defaultValue={90} min={30} max={365} className="bg-[#1A2433] border-gray-700 text-white" />
              </div>
            </div>
            
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="require-special" className="text-gray-300">Sonderzeichen erforderlich</Label>
                <p className="text-sm text-gray-500">Mindestens ein Sonderzeichen erforderlich</p>
              </div>
              <Switch id="require-special" defaultChecked />
            </div>
            
            <div className="flex items-center justify-between">
              <div>
                <Label htmlFor="history" className="text-gray-300">Passwort-Historie prüfen</Label>
                <p className="text-sm text-gray-500">Die letzten 5 Passwörter nicht wiederverwenden</p>
              </div>
              <Switch id="history" defaultChecked />
            </div>
          </div>
          
          <div className="pt-4">
            <Button className="mr-4 bg-[#1d4ed8] hover:bg-[#1e40af] text-white">
              <Key className="mr-2 h-4 w-4" />
              Einstellungen speichern
            </Button>
            <Button variant="outline" className="border-gray-700 text-gray-300 hover:bg-[#1A2433]">
              <Lock className="mr-2 h-4 w-4" />
              Zurücksetzen
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
